export default {
  badge: 'Configurazione in corso',
  title: 'Completa la configurazione del tuo ristorante',
  description: 'Mancano ancora alcuni passaggi prima che il ristorante possa andare live.',
  count: '{{done}} di {{total}} passaggi completati',
  cta: 'Continua configurazione',
  done: {
    badge: 'Tutto pronto',
    title: 'Tutto pronto',
    description: '{{partner}} attiverà il tuo ristorante.',
    fallback_partner: 'Il tuo provider',
  },
};
